export const theme = {
  border: "#F1F7ED",
  border100: "#5C5C5C",

  text: "#FFFFFF",
  background100: "#002E3D",

  green: "#4DBB60",
  yellow: "#FFFF00",
  red: "#FF0000",
  gray: "#E6E6E6",
} as const;
